import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './rating.css';
import '../icon/icon.js';

/**
 * Rating component properties
 * @property {number} max
 * @property {string} label
 */

export default class Rating extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            max: 5,
            label: '',
            rating: 0,
        };
    }

    events() {
        return {
            '.rating-button': {
                click: (event) => {
                    const ratingButtons = document.querySelectorAll('.rating-button');

                    for (const button of ratingButtons) {
                        button.classList.remove('selected');
                        button.classList.add('unselected');
                    }
                    const button = event.target.closest('button');

                    button.classList.add('selected');
                    button.classList.remove('unselected');

                    this.rating = button.getAttribute('data-value');
                },
            },
        };
    }

    getRating() {
        return this.rating;
    }

    template() {
        return html`
            <div
                class="rating-container flex flex-row gap-4"
                aria-label="${this.label}"
                aria-valuenow="${this.rating}"
                aria-valuemin="0"
                aria-valuemax="${this.max}"
            >
                ${Array.from({ length: this.max }, (_, i) => i + 1).map(
                    (index) => html`
                        <button class="rating-button unselected cursor-pointer" data-value="${index}">
                            <mb-icon name="app--star"></mb-icon>
                        </button>
                    `,
                )}
            </div>
        `;
    }
}

defineElement('mb-rating', Rating);
